import styled, { keyframes } from 'styled-components';

import { green } from 'utils/style/colors';

type ToggleSwitchProps = {
  loading: boolean;
};

type ToggleLoadingProps = {
  checked: boolean;
};

const SWITCH_SIZE = 22;
const SWITCH_BACKGROUND = '#D1D7E3';
const SWITCH_DOT = 'var(--exact-white)';
const SWITCH_ACTIVE = green;

const ring = keyframes`
  to {
    transform: rotate(360deg);
  }
`;

export const ToggleSlider = styled('div')`
  width: ${SWITCH_SIZE * 2}px;
  height: ${SWITCH_SIZE}px;
  border: 1px solid ${SWITCH_BACKGROUND};
  cursor: pointer;
  background: ${(props) => props.backgroundColor || SWITCH_BACKGROUND};
  border-radius: ${SWITCH_SIZE / 2}px;
  vertical-align: top;
  position: relative;
  display: inline-block;
  user-select: none;
  transition: all 0.3s ease;
  :before {
    content: '';
    float: left;
    width: ${SWITCH_SIZE - 6}px;
    height: ${SWITCH_SIZE - 6}px;
    background: ${SWITCH_DOT};
    pointer-events: none;
    margin-top: 2px;
    margin-left: 2px;
    border-radius: inherit;
    transition: all 0.4s ease 0s;
  }
`;

export const ToggleSwitch = styled('label')<ToggleSwitchProps>`
  margin: 0;
  position: relative;
  ${({ loading }) =>
    loading &&
    `
    pointer-events: none;
    ${ToggleSlider} {
      opacity: 0.7;
    }
  `}
  :hover {
    input {
      :disabled + ${ToggleSlider} {
        border-color: ${SWITCH_BACKGROUND};
      }
      :checked + ${ToggleSlider} {
        background: ${SWITCH_ACTIVE};
      }
    }
  }
`;

export const ToggleInput = styled('input')`
  display: none;
  cursor: pointer;
  :checked + ${ToggleSlider} {
    background: ${SWITCH_ACTIVE};
    border: 1px solid ${SWITCH_ACTIVE};
    :before {
      transform: translate(${SWITCH_SIZE}px, 0)}
    };
  }
  :disabled {
    cursor: default;
    + ${ToggleSlider} {
      cursor: default;
      opacity: 0.5;
    }
  }
  
`;

export const ToggleLoading = styled('div')<ToggleLoadingProps>`
  height: 12px;
  width: 12px;
  position: absolute;
  top: 3px;
  border: 2px solid transparent;
  border-radius: 50%;
  border-top-color: ${green};
  animation: ${ring} 600ms linear infinite;
  left: ${({ checked }) => (checked ? 'unset' : '5px')};
  right: ${({ checked }) => (checked ? '5px' : 'unset')};
`;
